import {Component, OnInit, ViewChild} from '@angular/core';
import {GA4EventDebugData, GoogleAnalyticsEventsService} from '../../../services/google-analytics-events.service';
import {ApplicationStateService} from '../../../services/application-state.service';

@Component({
  selector: 'app-ga4-events-log',
  templateUrl: './ga4-events-log.component.html',
  styleUrls: []
})
export class Ga4EventsLogComponent implements OnInit {

  expanded: boolean = false;
  private highlightedProperties: string[] = [
      'user_id'
  ];

  constructor(public googleAnalyticsService: GoogleAnalyticsEventsService,
              public stateService: ApplicationStateService) {
  }

  ngOnInit() {

  }

  toggle() {
    this.expanded = !this.expanded;
  }

  clear() {
    this.googleAnalyticsService.resetDebugData();
  }

  getEventName(eventData: GA4EventDebugData): string {
    if (eventData.payload) {
      return eventData.payload.event ? eventData.payload.event : '–';
    }
    return '–';
  }

  getPayloadProps(eventData: GA4EventDebugData): any[] {
    if (eventData.payload) {
      return Object.keys(eventData.payload).map(propertyName => ({
        propertyName: propertyName,
        value: eventData.payload[propertyName]
      }));
    }
    return [];
  }

  isPropertyHighlighted(propertyName: string): boolean {
    return this.highlightedProperties.includes(propertyName);
  }

}
